import { ArtData } from "../../../types";

type minimumArt = Pick<ArtData, "slug">;
export const isSameArt = (art1: minimumArt, art2: minimumArt) =>
  art1.slug === art2.slug;
export const getAltText = (art: Pick<ArtData, "author" | "title">) => {
  return art.title + " by: " + art.author;
};